<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__controls">
      <tab :active="isActive" @changeView="changeView"></tab>

      <template v-if="isActive === 'list'">
        <Select2
          :options="services"
          :settings="selectSetting"
          class="select mr-12"
          @select="selectMaster($event)"
          v-model="selectDataGetters"
        />

        <Select2
          :options="[
            { id: 'all', text: $t('listsHeader.all') },
            { id: 'true', text: $t('listsHeader.busy') },
            { id: 'false', text: $t('ordersStatus.free') },
          ]"
          :settings="{
            placeholder: $t('listsHeader.busy'),
            allowClear: false,
          }"
          v-model="params.busy"
          class="select mr-12"
          @select="filter"
        />

        <Select2
          v-if="filteredList"
          :options="filteredList"
          :settings="{
            placeholder: $t('forms.default'),
            allowClear: false,
          }"
          v-model="params.office_id"
          class="select mr-12"
          @select="filter"
        />

        <Select2
          :options="[
            { id: 'all', text: 'Aktiv' },
            { id: 'list', text: 'All' },
            { id: 'inactive', text: 'Inaktiv' },
          ]"
          :settings="{
            placeholder: 'Aktiv',
            allowClear: false,
          }"
          v-model="params.with"
          class="select mr-12"
          @select="filter"
        />

        <search @searchData="searchMaster" :value="search" class="search_h100" />
      </template>

      <template v-if="isActive === 'map'">
        <Select2
          :settings="{
            placeholder: $t('forms.master'),
            allowClear: false,
          }"
          :options="mastersToSelect"
          @select="openMasterMap($event)"
          class="mr-12"
        />

        <Select2
          :options="services"
          :settings="selectSetting"
          class="select mr-12"
          @select="selectMapServices($event)"
        />

        <datetime
          class="day-datepicker vdatetime_w190"
          :class="{
            'day-datepicker_inactive': '' == '',
            'disabled-datepicker': mapViewGetters === 'all',
          }"
          input-class="date-input"
          :placeholder="$t('request.dateHolder')"
          @input="setMapDay($event)"
          :disabled="mapViewGetters === 'all'"
        />
      </template>

      <template v-else-if="isActive === 'badges'"></template>

      <template v-else-if="isActive === 'schedule'"></template>
    </div>

    <template v-if="isLoad">
      <!-- <transition name="fade"> -->
      <component :is="activeComponent" :isActive="isActive" />
      <!-- </transition> -->
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import filtersView from '@/views/masters/filtersView'
import mainView from '@/views/masters/mainView'
import scheduleView from '@/views/masters/scheduleView'
import store from '../../store'

const type = 'masters'
export default {
    components: {
        'filters-view': filtersView,
        'main-view': mainView,
        'schedule-view': scheduleView,
    },
    data() {
        return {
            type,
            // isActive: "list",
            search: '',
            selectData: '',
            selectSetting: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            request: '',
            mastersToSelect: [],
            partners: [],
            isLoad: false,
            // officeList: null
        }
    },
    props: {
        isMap: {
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            services: 'servicesGettersWithAll',
            mapViewGetters: 'mapViewGetters',
            partnersSetting: 'specialists/partnersSettingGetters',
            isActive: 'specialists/isActive',
            partnersGetters: 'partners/partnersGetters',
            params: 'specialists/paramsGetters',
            filteredList: 'offices/filteredListAll',
            selectDataGetters: 'specialists/selectDataGetters',
        }),
        masters() {
            return this.$store.state.specialists.data
        },
        activeComponent() {
            if (this.isActive === 'badges') return 'filters-view'
            if (this.isActive === 'schedule') return 'schedule-view'
            else return 'main-view'
        },
    },
    beforeRouteLeave(to, from, next) {
        this.setOrderMapWindow(false)
        this.setMapDate(null)
        next()
    },
    methods: {
        ...mapMutations({
            setSearch: 'specialists/setSearch',
            setSelectData: 'specialists/setSelectData',
            setMapDate: 'setMapDate',
            setMapService: 'setMapService',
            setOrderMapWindow: 'setOrderMapWindow',
            setParams: 'specialists/setParams',
            clearParams: 'specialists/clearParams',
            setState: 'specialists/setState',
            setLink: 'setLink',
        }),
        ...mapActions({
            getMadDataById: 'getMadDataById',
            fetchMap: 'fetchMap',
            fetchPartners: 'partners/fetch',
            fetchSkills: 'skills/fetch',
            fetchTools: 'tools/fetch',
        }),
        changeView(view) {
            if (view === 'list') {
                this.setMapDate(null)
                this.setOrderMapWindow(false)
            }

            this.setState({
                type: 'isActive',
                data: view,
            })
        },
        searchMaster(data) {
            this.setSearch(data)
        },
        async filter() {
            await this.$store.dispatch('specialists/getSpecialistsData', { type })
        },
        selectMaster({ id }) {
            if (id === 'all') {
                this.setSelectData('')
                return
            }

            if (this.selectData !== id) {
                this.setSelectData(id)
            } else {
                this.setSelectData('')
            }
        },
        openMasterMap(e) {
            this.getMadDataById({ id: e.id, type: 'masters' })
        },
        setMapDay(e) {
            if (e !== '') {
                this.setMapDate(e)
                this.fetchMap({ type: 'masters' })
            }
        },
        selectMapServices({ id }) {
            this.setMapService(id)
        },
        async selectPartner() {
            await this.$store.dispatch('specialists/getSpecialistsData', { type })
        },
        preparemastersToSelect() {
            if (this.mastersToSelect.length === 0) {
                return
            }

            if (this.mastersToSelect[0].id !== 'all') {
                this.mastersToSelect.unshift({
                    text: this.$t('listsHeader.all'),
                    id: 'all',
                })
            }
        },
        prepareMaster() {
            this.masters.forEach((e) => {
                this.mastersToSelect.push({
                    id: e.id,
                    text: `${e.first_name} ${e.last_name}`,
                })
            })
        },
        preparePartners() {
            this.partnersGetters.forEach((element) => {
                this.partners.push({
                    id: element.id,
                    text: element.name,
                    is_active: undefined,
                })
            })

            if (this.partners.length === 0) {
                return
            }

            if (this.partners[0].id !== 'all') {
                this.partners.unshift({
                    text: this.$t('listsHeader.all'),
                    id: 'all',
                })
            }
        },
    },
    created() {
        if (!this.isMap) return

        this.setState({
            type: 'isActive',
            data: 'map',
        })
    },
    async beforeMount() {
        await store.dispatch('specialists/getSpecialistsData', { type })
        this.prepareMaster()
        this.preparemastersToSelect()

        await this.fetchPartners({})
        this.preparePartners()
        this.isLoad = true

        this.fetchSkills()
        this.fetchTools()
    },
    mounted() {
        this.setLink({
            key: 'infoRootLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-2101/78e2fe4e12c4d26/4hhzv-2101',
        })
        this.setLink({
            key: 'infoLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-801/6bcedeb5a7a2ac1',
        })
    },
    beforeDestroy() {
        this.clearParams()
        this.setSearch('')
        this.setSelectData('')
        this.setState({
            type: 'isActive',
            data: 'list',
        })

        this.setLink({
            key: 'infoRootLink',
            value: null,
        })
        this.setLink({
            key: 'infoLink',
            value: null,
        })
    },
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/main";

.masters {
  width: 100%;
  height: 100%;
  padding: 36px 60px 60px 60px;
  box-sizing: border-box;

  &__input {
    border-radius: 8px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    font-family: "SFUIDisplay-Regular";
    font-size: 14px;
    color: #61422d;
    padding-left: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    margin-top: 5px;
    outline: none;
    overflow: hidden;
    height: 40px;
    display: flex;
    align-items: center;
    width: 160px !important;
    margin-right: 15px;

    &:not(:last-child) {
      margin-right: 15px;
    }

    &:not(:first-child) {
      margin-left: 5px;
    }

    &_baseHeight {
      height: 40px;
    }
  }

  &__bottom {
    margin-top: 15px;
    display: flex;
  }

  &__head {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  // &__controls {
  //   margin-bottom: 16px;
  //   display: flex;
  // }

  & .select {
    max-width: 240px;
  }

  &__content {
    position: relative;
    height: 100%;
  }
}
</style>

<style>
.day-datepicker .date-input {
  height: 90% !important;
}

body .disabled-datepicker {
  cursor: not-allowed !important;
}

.disabled-datepicker .date-input {
  cursor: not-allowed !important;
}
</style>
